<div class="table-wrapper">

  <div class="table-header">
    <h1 class="table-title">{{ title }}</h1>
    <button *ngIf="showPostButton" class="btn-post" (click)="$event.stopPropagation(); onPostVacancy()">
      <svg class="btn-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
      </svg>
      {{ postButtonLabel }}
    </button>
  </div>

  <!-- ── Desktop Search ── -->
  <div class="search-row d-none d-md-block" *ngIf="searchKey" (click)="$event.stopPropagation()">
    <div class="search-box">
      <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M21 21l-4.35-4.35M16.65 16.65A7 7 0 1 0 4 11a7 7 0 0 0 12.65 5.65z" />
      </svg>
      <input class="search-input" type="text" [placeholder]="'Search...' | translate" [(ngModel)]="searchQuery"
        (ngModelChange)="onSearchChange()" (click)="$event.stopPropagation()" />
      <button *ngIf="searchQuery" class="btn-search-clear" (click)="clearSearch(); $event.stopPropagation()">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="14"
          height="14">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  </div>

  <!-- ── Desktop Filters ── -->
  <div class="filters-row desktop-only d-none d-md-flex">
    <div *ngFor="let filter of filters" class="filter-select-wrap">
      <label class="filter-label">{{ filter.label | translate }}</label>
      <div class="custom-select" [class.open]="openDropdown[filter.key]" (click)="toggleDropdown(filter.key, $event)">
        <div class="custom-select-trigger">
          <span>{{ (activeFilters[filter.key] === 'All' ? filter.label : activeFilters[filter.key]) | translate
            }}</span>
          <svg class="select-arrow" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
          </svg>
        </div>
        <div class="custom-select-dropdown" *ngIf="openDropdown[filter.key]" (click)="$event.stopPropagation()">
          <div class="custom-select-option" [class.option-active]="activeFilters[filter.key] === 'All'"
            (click)="selectOption(filter.key, 'All', $event)">{{ 'All' | translate }}</div>
          <div *ngFor="let opt of filter.options" class="custom-select-option"
            [class.option-active]="activeFilters[filter.key] === opt" (click)="selectOption(filter.key, opt, $event)">{{
            opt | translate }}</div>
        </div>
      </div>
    </div>
  </div>

  <!-- ── Mobile Filter Bar ── -->
  <div class="mobile-filter-bar mobile-only d-flex d-md-none" (click)="$event.stopPropagation()">
    <div class="search-row" *ngIf="searchKey" (click)="$event.stopPropagation()">
      <div class="search-box">
        <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
          stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M21 21l-4.35-4.35M16.65 16.65A7 7 0 1 0 4 11a7 7 0 0 0 12.65 5.65z" />
        </svg>
        <input class="search-input" type="text" [placeholder]="'Search...' | translate" [(ngModel)]="searchQuery"
          (ngModelChange)="onSearchChange()" (click)="$event.stopPropagation()" />
        <button *ngIf="searchQuery" class="btn-search-clear" (click)="clearSearch(); $event.stopPropagation()">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="14"
            height="14">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>

    <button class="btn-filter-open" [class.has-active]="activeFilterCount > 0" (click)="openFilterSheet()">
      <svg width="14" height="14" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4h18M7 8h10M11 12h2M9 16h6" />
      </svg>
      {{ 'Filters' | translate }}
      <span *ngIf="activeFilterCount > 0" class="filter-badge">{{ activeFilterCount }}</span>
    </button>

    <ng-container *ngFor="let filter of filters">
      <div class="active-chip" *ngIf="activeFilters[filter.key] !== 'All'">
        {{ activeFilters[filter.key] | translate }}
        <button (click)="removeChip(filter.key)">×</button>
      </div>
    </ng-container>
  </div>

  <!-- ── Mobile Bottom Sheet Overlay ── -->
  <div class="sheet-overlay mobile-only" [class.open]="filterSheetOpen" (click)="closeFilterSheet()"></div>

  <!-- ── Mobile Bottom Sheet ── -->
  <div class="bottom-sheet mobile-only" [class.open]="filterSheetOpen" (click)="$event.stopPropagation()">
    <div class="sheet-handle"></div>
    <div class="sheet-header">
      <span class="sheet-title">{{ 'Filter jobs' | translate }}</span>
      <button class="btn-clear-all" (click)="clearAllFilters()">{{ 'Clear all' | translate }}</button>
    </div>
    <div class="sheet-body">
      <div *ngFor="let filter of filters" class="sheet-section">
        <div class="section-label">{{ filter.label | translate }}</div>
        <div class="pill-group">
          <div class="pill" [class.pill-active]="activeFilters[filter.key] === 'All'"
            (click)="selectOption(filter.key, 'All', $event)">{{ 'All' | translate }}</div>
          <div *ngFor="let opt of filter.options" class="pill" [class.pill-active]="activeFilters[filter.key] === opt"
            (click)="selectOption(filter.key, opt, $event)">{{ opt | translate }}</div>
        </div>
      </div>
    </div>
    <div class="sheet-footer">
      <button class="btn-apply" (click)="closeFilterSheet()">{{ 'Show results' | translate }}</button>
    </div>
  </div>

  <!-- ── Desktop Table ── -->
  <div class="table-scroll desktop-only d-none d-md-block">
    <table class="job-table">
      <thead>
        <tr>
          <th *ngFor="let col of columns">{{ col.label | translate }}</th>
          <th class="col-actions">{{ 'Actions' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let job of pagedJobs; let i = index" class="table-row" [style.animation-delay]="i * 40 + 'ms'">
          <td *ngFor="let col of columns">
            <span *ngIf="col.isBadge; else buttonCell" class="badge" [ngClass]="getBadgeClass(col, job[col.key])">
              {{ job[col.key] | translate }}
            </span>
            <ng-template #buttonCell>
              <button *ngIf="col.isButton; else plainCell" class="btn-action {{ col.buttonClass }}"
                [disabled]="col.buttonDisabledKey ? !!job[col.buttonDisabledKey] : false"
                (click)="triggerAction(col.key, job)">
                {{ (col.buttonLabel || '') | translate }}
              </button>
            </ng-template>
            <ng-template #plainCell>
              <span [class.col-job-name]="col.key === 'jobName'" [class.col-position]="col.key === 'position'"
                [class.col-date]="col.key === 'publishedDate'">
                {{ job[col.key] }}
              </span>
            </ng-template>
          </td>
          <!-- ── Desktop Table actions cell ── -->
          <td class="col-actions">
            <button class="btn-action btn-edit" title="Edit" (click)="onEdit(job)">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="15"
                height="15">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5
               m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
              </svg>
              {{ 'Edit' | translate }}
            </button>
            <button *ngIf="showViewButton" class="btn-action btn-view" title="View" (click)="onView(job)">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="15"
                height="15">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7
               -1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              {{ 'View' | translate }}
            </button>
            <button *ngIf="showDeleteButton" class="btn-action btn-delete" title="Delete" (click)="onDelete(job)">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="15"
                height="15">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858
               L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
              {{ 'Delete' | translate }}
            </button>
          </td>
        </tr>
        <tr *ngIf="pagedJobs.length === 0">
          <td [attr.colspan]="columns.length + 1" class="no-results">{{ 'No jobs match your filters.' | translate }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- ── Mobile Cards ── -->
  <div class="cards-container mobile-only d-block d-md-none">
    <div *ngFor="let job of pagedJobs; let i = index" class="job-card" [style.animation-delay]="i * 50 + 'ms'">
      <div class="card-body" [ngClass]="{ 'two-columns': !columns[0].isBadge }">
        <div *ngFor="let col of columns" class="card-field">
          <span class="card-field-label">{{ col.label | translate }}</span>
          <span *ngIf="col.isBadge; else buttonCardCell" class="badge" [ngClass]="getBadgeClass(col, job[col.key])">
            {{ job[col.key] | translate }}
          </span>
          <ng-template #buttonCardCell>
            <button *ngIf="col.isButton; else plainCardCell" class="btn-action {{ col.buttonClass }}"
              [disabled]="col.buttonDisabledKey ? !!job[col.buttonDisabledKey] : false"
              (click)="triggerAction(col.key, job)">
              {{ (col.buttonLabel || '') | translate }}
            </button>
          </ng-template>
          <ng-template #plainCardCell>
            <span [class.col-job-name]="col.key === 'jobName'" [class.col-position]="col.key === 'position'"
              [class.col-date]="col.key === 'publishedDate'">
              {{ job[col.key] }}
            </span>
          </ng-template>
        </div>
      </div>
      <!-- ── Mobile Card actions ── -->
      <div class="card-actions">
        <button class="btn-action btn-edit btn-card-action" (click)="onEdit(job)">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="15"
            height="15">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5
               m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
          </svg>
          {{ 'Edit' | translate }}
        </button>
        <button *ngIf="showViewButton" class="btn-action btn-view btn-card-action" (click)="onView(job)">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="15"
            height="15">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7
               -1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
          {{ 'View' | translate }}
        </button>
        <button *ngIf="showDeleteButton" class="btn-action btn-delete btn-card-action" (click)="onDelete(job)">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="15"
            height="15">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858
               L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
          </svg>
          {{ 'Delete' | translate }}
        </button>
      </div>
    </div>
    <div *ngIf="pagedJobs.length === 0" class="no-results">{{ 'No jobs match your filters.' | translate }}</div>
  </div>

  <!-- ── Pagination ── -->
  <div class="pagination-row" *ngIf="totalPages > 1">
    <span class="pagination-info">
      {{ 'Showing' | translate }} {{ firstItem }}–{{ lastItem }} {{ 'of' | translate }} {{ serverSidePagination ?
      totalElements : filteredJobs.length }} {{ 'results' | translate }}
    </span>
    <div class="pagination-controls">
      <button class="page-btn nav-btn" [disabled]="activePage === 1" (click)="goToPage(activePage - 1)">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="16"
          height="16">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
        </svg>
      </button>
      <ng-container *ngFor="let p of pageNumbers">
        <span *ngIf="p === -1" class="page-dots">...</span>
        <button *ngIf="p !== -1" class="page-btn" [class.page-active]="p === activePage" (click)="goToPage(p)">
          {{ p }}
        </button>
      </ng-container>
      <button class="page-btn nav-btn" [disabled]="activePage === totalPages" (click)="goToPage(activePage + 1)">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="16"
          height="16">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>
  </div>

</div>